var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleTable',{attrs:{"formclass":"File/form","endpoint":"files","aditionalColumns":_vm.headers,"forceReloadOnChange":true,"keepOpenFormOnSave":"false"}},[[_c('h1',[_vm._v("Arquivos")]),_c('v-divider',{staticClass:"mb-4"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }